import LoadingBar from "components/loading-bar";
import { FunctionComponent, PropsWithChildren, createContext, useContext, useState } from "react";

export const LoadingContext = createContext<{ loading: boolean; setLoading: (val: boolean) => void }>({} as any);

interface LoadingProviderProps extends PropsWithChildren {}

export const useLoading = () => useContext(LoadingContext);

const LoadingProvider: FunctionComponent<LoadingProviderProps> = ({ children }) => {
  const [loading, setLoading] = useState(false);
  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {!loading ? null : <LoadingBar />}
      {children}
    </LoadingContext.Provider>
  );
};

export default LoadingProvider;
